import _ from 'lodash'
import apiFactory from './api-factory'
import { dehydrate as branchDehydrate } from './branch'

const branchingQuestion = {
  ...apiFactory('/api/polls/branching_question/', ['getList'], { dehydrate }),

  getListForParentPoll(poll, params, context) {
    return this.getList(
      {
        ...params,
        parent_poll: poll,
      },
      context
    )
  },

  getListForParentBranchingQuestion(branchingQuestion, params, context) {
    return this.getList(
      {
        ...params,
        parent_branching_question: branchingQuestion,
      },
      context
    )
  },
}

export function dehydrate({ pk, name, branches }) {
  return {
    type: 'branchingQuestions',
    pk,
    name,
    branches: _.map(branches, branchDehydrate),
  }
}

export default branchingQuestion
